export default __webpack_public_path__ + "static/media/choose_school.c7f2b371.gif";